import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { VocText } from './shared.css'

const VocPlaceholderText = styled(VocText).attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.vocComingSoon
})`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

const VocComingSoon = () => {
  const theme = useDisplayTheme() as Theme
  return (
    <VocPlaceholderText mode={theme}>
      Star Ratings, Survey Scores, and NPS coming soon for VoC customers.&nbsp;
      <a target="_blank" rel="noreferrer" href="https://help.quid.com/articles/8258254">
        More...
      </a>
    </VocPlaceholderText>
  )
}

export default VocComingSoon
